import React from 'react';
import { Card, Divider, List, Typography } from 'antd';
import { useEffect } from 'react';
import { useState } from 'react';

function FileConversionTasksView({ conversiontasks = [] }) {
    const [data, setData] = useState([])
    const [hidden, setHidden] = useState(true)

    useEffect(() => {
        setData(conversiontasks);
    }, [conversiontasks])

    const getTitle = (totalFiles) => {
        if (totalFiles > 1) {
            return `${conversiontasks.length} files are being processed`
        }
        else {
            return `${conversiontasks.length} file is being processed`
        }
    }
    return (
        <div style={{ position: "fixed", bottom: "0", right: "30px", zIndex: 10000, display: conversiontasks.length ? "block" : "none" }}>
            <Card
                title={getTitle(conversiontasks.length)}
                extra={<a href="#" onClick={() => { setHidden(!hidden) }}>{hidden ? "Show" : "Hide"}</a>}
                style={{
                    width: 350,
                    maxHeight: 500,
                }}
            >
                {!hidden && <List
                    // header={<div>Header</div>}
                    // footer={<div>Footer</div>}
                    // bordered
                    dataSource={data}
                    renderItem={(item) => (
                        <List.Item>
                            <List.Item.Meta
                                title={item.FileName}
                                description={item.FileType}
                            />
                            <div>{item.Status}</div>
                        </List.Item>
                    )}
                />}

            </Card>
        </div >
    );
}

export default FileConversionTasksView;